document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-nav]');
  if (menuButton && navigation) {
    menuButton.addEventListener('click', () => {
      const isOpen = navigation.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
  }
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-main-image');
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
    if (!mainImage || !thumbnails.length) return;
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        mainImage.src = thumbnail.dataset.imageSrc;
        mainImage.srcset = '';
        mainImage.alt = thumbnail.dataset.imageAlt || '';
        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-current', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-current', 'true');
      });
    });
  });
});
